import { UPLOAD_ALLOWED_FILE_TYPES } from "shared/config/constants";

export const ATTACHMENTS_ALLOWED_FILE_TYPES = [...UPLOAD_ALLOWED_FILE_TYPES];

export const ATTACHMENTS_ALLOWED_FILE_TYPES_STRING =
  ATTACHMENTS_ALLOWED_FILE_TYPES.join(",");
